import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-4">Article Not Found</h1>
          <p className="text-foreground-500 mb-6">The article you are looking for does not exist.</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </div>
    );
  }

  return <ArticleLayout article={article} />;
}